
export enum ArtCategory {
  ANIMATED = 'Animated',
  STATIC = 'Static',
  BLACK_AND_WHITE = 'Black and White',
  WORKSHOP = 'Workshop',
  AVATAR = 'Avatar',
  CLIENT_ORDERS = 'Client Orders',
  DISCORD_BANNER = 'Discord Banner',
  WALLPAPER = 'Wallpaper / Background'
}

export type Language = 'pt' | 'en';

export interface ArtItem {
  id: string;
  title: {
    pt: string;
    en: string;
  };
  category: ArtCategory;
  subcategory?: string;
  artType?: string;
  price: number; 
  imageUrl: string;
  videoUrl?: string; 
  steamBackgroundUrl?: string;
  description: {
    pt: string;
    en: string;
  };
  isAnimated: boolean;
  notForSale?: boolean;
}

export interface CartItem extends ArtItem {
  quantity: number;
  customSignature?: string;
  customFont?: string;
  dafontLink?: string;
  discord?: string;
  steamUrl?: string;
  sigPosX?: number;
  sigPosY?: number;
  sigScale?: number;
  sigColor?: string;
  notes?: string;
}

export interface DailyVisit {
  date: string;
  count: number; // Mantido por compatibilidade, será o uniqueCount
  totalCount: number;
  uniqueCount: number;
}

export interface Comment {
  id: string;
  userName: string;
  userEmail: string;
  text: string;
  date: string;
  reply?: string; 
  rating?: number;
  verified?: boolean;
}

export interface ProfileConcept {
  style: string;
  description: string;
  recommendedColors: string[];
  suggestedGames: string[];
}

export interface CommissionTier {
  id: string;
  title: string;
  demoUrl: string;
  features: string[];
  price?: number;
  maxPrice?: number;
  description?: string;
}

export enum OrderStatus {
  PENDING = 'Pendente',
  COMPLETED = 'Concluído',
  CANCELLED = 'Cancelado'
}

export interface Order {
  id: string;
  userId: string;
  userName: string;
  userEmail: string;
  items: CartItem[];
  total: number;
  date: string;
  status: OrderStatus;
}

export enum SupportStatus {
  PENDING = 'Pendente',
  RESOLVED = 'Resolvido'
}

export interface SupportMessage {
  id: string;
  userName: string;
  userEmail: string;
  message: string;
  date: string;
  status: SupportStatus;
}

export interface ChatMessage {
  id: string;
  sender: 'user' | 'admin';
  text: string;
  imageUrl?: string; 
  timestamp: string;
}

export interface ChatThread {
  userEmail: string;
  userName: string;
  messages: ChatMessage[];
  lastUpdated: string;
  unreadCount: number;
}

export interface User {
  name: string;
  email: string;
  avatarUrl?: string;
  password?: string; 
}

export interface FAQItem {
  id: string;
  question_pt: string;
  question_en: string;
  answer_pt: string;
  answer_en: string;
}

export interface SiteSettings {
  customRequestIntro_pt: string;
  customRequestIntro_en: string;
  deviantartUrl?: string;
  telegramUrl?: string;
  discordUrl?: string;
  faqs?: FAQItem[];
}
